import { api } from './index';

const ResalesRequestService = {
  get(params) {
    return api.get('companies/', params);
  },
  store(params) {
    return api.post('companies', params)
  },
  getAllDetails(params) {
    return api.get('companies/full-details', params);
  },
  getAll(params) {
    return api.get('companies/all', params);
  },
  // elite
  getRevenue(params) {
    return api.get('revenues/', params);
  },
  getRevenue2(params) {
    return api.get('revenues/get-revenues', params);
  },
  getByClient(params) {
    return api.get('revenues/by-client/', params);
  },
  getByClientManufacturer(params) {
    return api.get('revenues/by-client-manufacturer/', params);
  },
  getByManufacturer(params) {
    return api.get('revenues/by-manufacturer/', params);
  },
  getByManufacturerDash(params) {
    return api.get('revenues/by-manufacturer-dash/', params);
  },
//revenues/by-manufacturer-dash
  getAllExport(params) {
    return api.get('company-request-export', params);
  },
  getResale(id, params) {
    return api.get('companies/' + id, params);
  },
  saveResale(id, form) {
    return api.put('company-request/' + id, form);
  },
  getInfoResale() {
    return api.get('revenues/info-form');
  },
  getResaleContacts(id) {
    return api.get('company-request/contacts/' + id);
  },
  updateResaleContacts(id, form) {
    return api.put('company-request/contacts/' + id, form);
  },
  getResaleBUs(id) {
    return api.get('company-request/bus/' + id);
  },
  updateResaleBUs(id, form) {
    return api.put('company-request/bus/' + id, form);
  },
  getResaleAttendance(params) {
    return api.get('companies/attendance-users', params);
  },
  getResaleBrands(id, params) {
    return api.get('company-request/brands/' + id, params);
  },
  getResaleLeadHistory(id, params) {
    return api.get('company-request/lead-history/' + id, params);
  },
  // elite
  getCompanyFunds(id, params) {
    return api.get('companies/' + id + '/funds/', params);
  },
  getCompanyByMonth(params) {
    return api.get('revenues/by-month/', params);
  },
  getCompareLast(params) {
    return api.get('revenues/compare-last/', params);
  },
  getLastDateRevenue(params) {
    return api.get('revenues/last-date/', params);
  },

  getTotalActiveCompanies(params) {
    return api.get('programs/total-active-companies/', params);
  },
  getAcceleratorsCount(params) {
    return api.get('rankings/accelerators-count/', params);
  },

  getBus(params) {
    return api.get('business-unities/', params);
  },
  getAcceleratorsAll(params) {
    return api.get('accelerators/all', params)
  },
  getAcceleratorsByCategory(params) {
    return api.get('accelerators/get-by-category', params)
  },
  getAccelerators(params) {
    return api.get('accelerators', params);
  },
  getByGroup(params) {
    return api.get('companies/by-group', params);
  },

  getFiscalYears(params) {
    return api.get('fiscal-years', params);
  },
  // getCompanyGroup(id, params) {
  //   return api.get('company-groups/' + id, params);
  // },
  getCompanyGroup(id, params) {
    return api.get(`companies/group-invoicing/${id}`, params);
  },
  getAreaResales(area_id, params) {
    return api.get('/area-resales/' + area_id, params);
  },
  getInfoHubspot(id, params) {
    return api.get('companies/' + id + '/info-hubspot/', params);
  },
  getLeads(id, params) {
    return api.get('companies/' + id + '/leads/', params);
  },
  getGroupHeadquarter(params) {
    return api.get('companies/group-headquarter', params);
  },
  verifyLimitUsers(id) {
    return api.get(`companies/${id}/verify-users-limit`)
  },
  getMaster() {
    return api.get('companies/master');
  },
  sendMailRevenues(params) {
    return api.post('resales/sendMailRevenues', params);
  },
  getManufacturers() {
    return api.get('resales/manufacturers');
  },
  getUsersProductProfileManufacturer(manufacturer_id) {
    return api.get('resales/users-product-profile-manufacturer/' + manufacturer_id)
  },
  getValueDashboard(params) {
    return api.get('companies/value-dashboard/', params);
  },
  getRankingByMonths(params) {
    return api.get('companies/ranking-by-months', params);
  },
  getForSelect(params) {
    return api.get('companies/get-for-select', params);
  },
  updateCategory(id, params) {
    return api.post(`companies/${id}/update-category`, params)
  },
  confirmAdhesion(params) {
    return api.post('companies/confirm-adhesion', params)
  },
  checkIsAvailable(document, { cancelToken }) {
    return api.get(`companies/check-is-available/${document}`, { cancelToken })
  },
  verifyAlreadyExists(document) {
    return api.get(`companies/verify-exists/${document}`)
  },
  getToNotifications(params) {
    return api.get("companies/to-notifications", params)
  },
  getCompaniesMasterAgent(params) {
    return  api.get("companies/master-agent", params)
  }
};

export default ResalesRequestService;